import {
  KeycloakTokenManipulate,
  RestAPI,
  routes,
  TokenManipulate,
  User,
  useRedirect,
} from '@builddocs/data-management'
import { useDisclosure } from '@builddocs/system'
import { MenuItem, Stack, Tooltip, Typography } from '@mui/material'
import { NotificationModal } from 'libs/feature-viewer/src'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router'

export const UserOption = ({
  account,
  isActive,
}: {
  account: User
  isActive: boolean
}) => {
  const {
    isOpen: isOpenNotification,
    onOpen: onOpenNotification,
    onClose: onCloseNotification,
  } = useDisclosure()

  const { mutateAsync: getAccountToken } = useMutation({
    mutationFn: (userId: string) =>
      RestAPI.post(
        `/tokens/jwt/refresh?userId=${userId}`,
        localStorage.getItem('token'),
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            'Content-Type': 'text/plain',
          },
        },
      ),
  })

  const redirect = useRedirect()

  const handleClick = async () => {
    // @ts-expect-error TODO: add selectAvailable to User type
    if (account.selectAvailable) {
      const { data: tokens } = await getAccountToken(account.userId)

      redirect('/')
      TokenManipulate.remove()
      KeycloakTokenManipulate.remove()
      TokenManipulate.print(tokens.jwtToken, tokens.refreshToken)
    } else {
      onOpenNotification()
    }
  }

  const navigate = useNavigate()

  const handleLogout = () => {
    navigate(routes.auth.logout())
  }

  return (
    <>
      <NotificationModal
        message="Для данной учётной записи вход доступен только через партнерский вход."
        open={isOpenNotification}
        title="Выйти?"
        onClose={onCloseNotification}
        onOk={handleLogout}
      />
      <Tooltip
        arrow
        disableInteractive
        PopperProps={{
          modifiers: [{ name: 'flip', enabled: false }],
        }}
        placement="top"
        title={
          !isActive ? (
            <Typography sx={{ fontSize: '14px', lineHeight: '20px' }}>
              Выбрать учетную запись
            </Typography>
          ) : undefined
        }
      >
        <MenuItem
          disabled={isActive}
          sx={{
            borderRadius: '8px',
            padding: '8px',
            backgroundColor: isActive ? '#EAEEF8' : 'transparent',
            '&:hover': {
              backgroundColor: '#EAEEF8',
            },
            '&:active': {
              backgroundColor: '#EAEEF8',
            },
          }}
          onClick={handleClick}
        >
          <Stack direction="column">
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: '14px',
                lineHeight: '20px',
                letterSpacing: '0px',
                color: '#333',
              }}
            >
              {[account.firstName, account.lastName].filter(Boolean).join(' ')}
            </Typography>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: '12px',
                lineHeight: '16px',
                letterSpacing: '0px',
                color: '#777',
              }}
            >
              {account.email}
            </Typography>
            <Typography
              sx={{
                fontWeight: 400,
                fontSize: '12px',
                lineHeight: '16px',
                letterSpacing: '0px',
                color: '#777',
              }}
            >
              {/* @ts-expect-error TODO: add companyName to User type */}
              {account.companyName}
            </Typography>
          </Stack>
        </MenuItem>
      </Tooltip>
    </>
  )
}
